import { useParams, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AppContext } from "../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";
import { toast, Toast } from "react-toastify";
import GetToken from "../../GetToken";
import { handleInvalidToken } from "../../AuthUtils";
import AnimationSpinner from "../../AnimationSpinner";

// React icons import
import { IoIosArrowRoundForward } from "react-icons/io";

// Material UI import
import Button from "@mui/material/Button";
import { Calendar, Eye, Edit, Trash2, Download } from "react-feather";
import { Pagination, Dialog, DialogTitle, DialogContent } from "@mui/material";
// bootstrap import
import { Card } from "react-bootstrap";

// custom component import
import SearchInput from "../../components/custom-components/SearchInput";
import { FaPlus } from "react-icons/fa";
import ErrorComponent from "./../NoDataFound.jsx/NoError";
import EmptyIcon from "../../assets/images/error-image.jpg";
const ManageTemplate = () => {
	const [loading, setLoading] = useState(false);
	const [items, setItems] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(6);
	const [totalItems, setTotalItems] = useState(0);
	const [searchTerm, setSearchTerm] = useState("");
	const { base_url } = useContext(AppContext);
	const navigate = useNavigate();
	const [entries, setEntries] = useState(10);
	const [viewImage, setViewImage] = useState(null);
	const handleEntriesChange = (e) => {
		setEntries(parseInt(e.target.value));
		setCurrentPage(1);
	};

	const handlePageChange = (event, value) => {
		setCurrentPage(value);
	};

	const fetchPageData = async () => {
		try {
			const token = GetToken();
			if (!token) {
				handleInvalidToken(navigate);
				return;
			}
			setLoading(true);
			const formData = new FormData();
			formData.append("action", "getUserBookCovers");
			formData.append("token", token);
			formData.append("offset", currentPage);
			formData.append("limit", itemsPerPage);
			formData.append("search", searchTerm);
			const response = await axios.post(
				`${base_url}api/user/get-user-resource`,
				formData
			);

			if (response.data.status === true) {
				setItems(response.data.items || []);
				setTotalItems(response.data.totalItems || 0);
				setTimeout(() => {
					setLoading(false);
				}, 1500);
			} else {
				setLoading(false);
				if (response.data.reset === true) {
					handleInvalidToken(navigate);
					return;
				}
				toast.warning(response.data.message);
				// Swal.fire({
				// 	icon: "warning",
				// 	title: "Warning",
				// 	text: response.data.message,
				// });
			}
		} catch (error) {
			setLoading(false);
			toast.error(error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again.");
			// Swal.fire({
			// 	icon: "error",
			// 	title: "Error",
			// 	text:
			// 		error.response?.data?.message ||
			// 		error.message ||
			// 		"Something went wrong. Please try again.",
			// });
		}
	};

	useEffect(() => {
		fetchPageData();
	}, [currentPage, navigate, searchTerm, itemsPerPage]);

	const totalPages = Math.ceil(totalItems / itemsPerPage);

	const handleEditTemplate = (ids, slug) => {
		const bookURL = `${base_url}book/cover/design/?image=${slug}&ids=${ids}`;
		window.open(bookURL, "_blank");
	};
	const handleDeleteTemplate = async (ids) => {
		const result = await Swal.fire({
			title: "Confirm Deletion",
			html: `<p>⚠️ <strong>Are you sure you want to delete this book template? This action is permanent and cannot be undone.</strong></p>`,
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Delete",
			cancelButtonText: "Cancel",
		});

		if (result.isConfirmed) {
			try {
				const token = GetToken();
				if (!token) {
					handleInvalidToken(navigate);
					return;
				}
				setLoading(true);
				const formData = new FormData();
				formData.append("action", "removeUserBookTemplate");
				formData.append("token", token);
				formData.append("template_ids", ids);
				const response = await axios.post(
					`${base_url}api/user/get-user-resource`,
					formData
				);

				if (response.data.status === true) {
					fetchPageData();
					toast.success("The book template has been successfully deleted.");
					// Swal.fire(
					// 	"Success",
					// 	"The book template has been successfully deleted.",
					// 	"success"
					// );
					setLoading(false);
				} else {
					setLoading(false);
					if (response.data.reset === true) {
						handleInvalidToken(navigate);
						return;
					}
					toast.warning(response.data.message);
					// Swal.fire({
					// 	icon: "warning",
					// 	title: "Warning",
					// 	text: response.data.message,
					// });
				}
			} catch (error) {
				setLoading(false);
				Swal.fire(
					"Error",
					"Failed to delete the book template. Please try again.",
					"error"
				);
			}
		}
	};

	const handleDownloadTemplate = (imageUrl) => {
		const link = document.createElement("a");
		link.href = imageUrl;
		link.download = "book_cover.jpg";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<>
			<AnimationSpinner show={loading} />
			<div className="right-container">
				<div className="row align-items-center">
					<div className="col-lg-6 page-title-container">
						<h4 className="fw-semibold mb-1">Manage Book Template</h4>
						<p className="mb-1">Manage your book template </p>
					</div>
					<div className="col-lg-6 justify-content-end">
						<div className="d-flex justify-content-end gap-4">
							<Button
								onClick={() => navigate("/book/template")}
								variant="contained"
								color="secondary"
								title="Create Book Template"
								className="ms-2"
								sx={{
									minWidth: "35px",
									height: "38px",
									padding: "0 17px",
								}}
							>
								<FaPlus color="white" style={{ marginRight: "5px" }} />
								Create Book Template
							</Button>
						</div>
					</div>
				</div>

				{items.length > 0 && <div className="row align-items-center mt-4 px-4">
					<div className="col-lg-6">
						<div className="d-flex align-items-center">
							<span className="me-2">Show</span>
							<select
								className="form-select form-select-sm"
								style={{ width: "70px" }}
								value={entries}
								onChange={handleEntriesChange}
							>
								<option value={5}>5</option>
								<option value={10}>10</option>
								<option value={25}>25</option>
								<option value={50}>50</option>
								<option value={100}>100</option>
							</select>
							<span className="ms-2">entries</span>
						</div>
					</div>
					<div className="col-lg-6 d-flex justify-content-end">
						<SearchInput
							searchTerm={searchTerm}
							setSearchTerm={setSearchTerm}
							borderColor="var(--primary-color)"
						/>
					</div>
				</div>}

				{items.length > 0 ? (
					<div className="row mt-5 ms-4">
						{items.map((card) => (
							<div className="col-md-3 mb-3" key={card.ids}>
								<Card className="interactive-card border-0 shadow-md">
									<div className="interactive-card__image-container">
										<img
											src={card.cover_image_url || "/placeholder.svg"}
											alt={card.bookcover_name}
											className="interactive-card__img"
										/>
										<div className="interactive-card__overlay"></div>

										<div className="interactive-card__button-container">
											<div className="interactive-card__button-group">
												<Button
													onClick={() =>
														handleEditTemplate(card.ids, card.json_file_url)
													}
													className="interactive-card__icon-btn"
													title="Edit template"
												>
													<Edit size={16} />
												</Button>
												<Button
													onClick={() => setViewImage(card.cover_image_url)}
													className="interactive-card__icon-btn"
													title="View template"
												>
													<Eye size={16} />
												</Button>
												<Button
													onClick={() =>
														handleDownloadTemplate(card.cover_image_url)
													}
													className="interactive-card__icon-btn"
													title="Download template"
												>
													<Download size={16} />
												</Button>
												<Button
													onClick={() => handleDeleteTemplate(card.ids)}
													className="interactive-card__icon-btn"
													title="Delete template"
												>
													<Trash2 size={16} />
												</Button>
											</div>
										</div>
									</div>
									<Card.Body>
										<h3 className="interactive-card__title">{card.name}</h3>
										<div className="interactive-card__date">
											<Calendar size={12} className="interactive-card__icon" />
											{card.created_at}
										</div>
									</Card.Body>
								</Card>
							</div>
						))}
					</div>
				) : (
          <>
          <ErrorComponent image={EmptyIcon} description={"No templates available, please try creating one."} />
          </>
				)}

				{totalPages > 1 && (
					<div className="d-flex justify-content-center mt-4">
						<Pagination
							count={totalPages}
							page={currentPage}
							onChange={handlePageChange}
							color="primary"
							shape="rounded"
						/>
					</div>
				)}
			</div>

			<Dialog open={!!viewImage} onClose={() => setViewImage(null)}>
				<DialogTitle>View Book Cover</DialogTitle>
				<DialogContent>
					<img src={viewImage} alt="Book Cover" style={{ width: "100%" }} />
				</DialogContent>
			</Dialog>
		</>
	);
};

export default ManageTemplate;
